import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fixedDates", "proposedDates", "fixedRadio", "votingRadio"]

  connect() {
    this.updateVisibility()
  }

  selectFixed(event) {
    if (event.target.tagName !== "INPUT") {
      this.fixedRadioTarget.checked = true
    }
    this.updateVisibility()
  }

  selectVoting(event) {
    if (event.target.tagName !== "INPUT") {
      this.votingRadioTarget.checked = true
    }
    this.updateVisibility()
  }

  updateVisibility() {
    const isVoting = this.votingRadioTarget.checked
    const dateInputs = this.fixedDatesTarget.querySelectorAll("input[type='date']")

    if (isVoting) {
      this.fixedDatesTarget.classList.add("hidden")
      this.proposedDatesTarget.classList.remove("hidden")
      dateInputs.forEach(input => input.removeAttribute("required"))
    } else {
      this.fixedDatesTarget.classList.remove("hidden")
      this.proposedDatesTarget.classList.add("hidden")
      dateInputs.forEach(input => input.setAttribute("required", "required"))
    }
  }

  addDateField() {
    const container = document.getElementById("proposed-dates-list")
    const wrapper = document.createElement("div")
    wrapper.className = "proposed-date-item flex items-center gap-2"
    wrapper.innerHTML = `
      <input type="date" name="trip[proposed_dates][]" class="block w-full rounded-lg border border-stone-200 dark:border-stone-600 bg-white dark:bg-stone-700 text-stone-900 dark:text-stone-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-fern-500 focus:border-fern-500 transition-colors">
      <button type="button" data-action="click->date-mode#removeDateField" class="text-stone-400 hover:text-red-500 p-1 flex-shrink-0 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    `
    container.appendChild(wrapper)
  }

  removeDateField(event) {
    const item = event.target.closest(".proposed-date-item")
    if (item) item.remove()
  }
}
